import React, { useState, useEffect } from "react";

const AddressAddon = ({ data, handleChange }) => {
  const [state, setState] = useState({
    addons: data,
  });
  const [isChange, setIsChange] = useState(false);

  useEffect(() => {
    setState({ addons: data });
  }, [data]);

  useEffect(() => {
    handleChange(state.addons);
  }, [isChange]);

  const addRow = (e) => {
    e.preventDefault();
    setState((pre) => ({
      ...pre,
      addons: [...pre.addons, ""],
    }));
  };

  const deleteRow = (e, index) => {
    e.preventDefault();
    const addons = state.addons.filter((e, i) => i !== index);
    setState({
      addons: [...addons],
    });
    setIsChange(!isChange);
  };

  const changeRowvalue = (e, i) => {
    const { name, value } = e.target;
    setState((pre) => ({
      ...pre,
      addons: [...pre.addons.slice(0, i), value, ...pre.addons.slice(i + 1)],
    }));
    setIsChange(!isChange);
  };

  return (
    <>
      {state.addons &&
        state.addons.map((s, i) => {
          return (
            <div className="col-md-8 my-2">
              <div className="row align-items-center">
                <div className="col-md-8 pe-0">
                  <div className="range-inner col-md-">
                    <input
                      type="text"
                      name="address"
                      value={s}
                      onChange={(e) => changeRowvalue(e, i)}
                      placeholder=""
                      className="form-control"
                    />
                  </div>
                </div>
                {i ? (
                  <div className="col-md-4">
                    <button
                      className="remove-btn address-btn-remove address-remove position-relative"
                      onClick={(e) => deleteRow(e, i, "addons")}
                    >
                      Remove
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          );
        })}
      <div className="expension-btn text-left">
        <button
          type="button"
          className="expension-button text-center"
          data-toggle="modal"
          data-target="#exampleModalScrollable1"
          onClick={(e) => addRow(e, "addons")}
        >
          Add More
        </button>
      </div>
    </>
  );
};

export default React.memo(AddressAddon);
